import React, { useEffect, useState  } from "react";
import axios from "axios";
import { baseUrl } from "../Univ";
import ReactSlider from "react-slider";

function Filters({ applyFilter }) {

  const [categories, setCategories] = useState([]);
  const [ratings, setRatings] = useState([]);

  const [priceRange, setPriceRange] = useState([100, 100000]);
  const [discountRange, setDiscountRange] = useState([0, 90]);

  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedRating, setSelectedRating] = useState("");
  const [sortBy, setSortBy] = useState("");

  // -----------------------
  // FETCH DROPDOWNS
  // -----------------------
  useEffect(() => {
    axios.get(baseUrl + "categories/")
      .then(res => setCategories(res.data));

    axios.get(baseUrl + "review/")
      .then(res => setRatings(res.data));
  }, []);

  // -----------------------
  // BUILD QUERY STRING
  // -----------------------
  useEffect(() => {

    const params = new URLSearchParams();

    params.append("min_price", priceRange[0]);
    params.append("max_price", priceRange[1]);

    params.append("min_discount", discountRange[0]);
    params.append("max_discount", discountRange[1]);

    if (selectedCategory) {
      params.append("category", selectedCategory);
    }

    if (selectedRating) {
      params.append("min_rating", selectedRating);
    }

    if (sortBy) {
      params.append("sort", sortBy);
    }

    applyFilter(params.toString());

  }, [
    priceRange,
    discountRange,
    selectedCategory,
    selectedRating,
    sortBy,
    applyFilter
  ]);

  return (
    <div className="p-3 mb-4 border rounded bg-light d-flex flex-wrap gap-3">

      {/* CATEGORY */}
      <div style={{ minWidth: 160 }}>
        <label>Category</label>
        <select
          className="form-select"
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          <option value="">All</option>
          {categories.map(c => (
            <option key={c.id} value={c.name}>
              {c.name}
            </option>
          ))}
        </select>
      </div>

      {/* PRICE */}
      <div style={{ minWidth: 250 }}>
        <label>
          Price: ₹{priceRange[0]} - ₹{priceRange[1]}
        </label>

      <ReactSlider
          min={100}
          max={100000}
          value={priceRange}
          onChange={setPriceRange}
          pearling
          minDistance={100}

          className="horizontal-slider"
          thumbClassName="slider-thumb"
          trackClassName="slider-track"
        />

      </div>

      {/* DISCOUNT */}
      <div style={{ minWidth: 250 }}>
        <label>
          Discount: {discountRange[0]}% - {discountRange[1]}%
        </label>

        <ReactSlider
          min={0}
          max={100}
          value={discountRange}
          onChange={setDiscountRange}
          pearling
          minDistance={5}

          className="horizontal-slider"
          thumbClassName="slider-thumb"
          trackClassName="slider-track"
        />

      </div>

      {/* RATING */}
      <div style={{ minWidth: 120 }}>
        <label>Rating</label>
        <select
          className="form-select"
          value={selectedRating}
          onChange={(e) => setSelectedRating(e.target.value)}
        >
          <option value="">All</option>
          <option value="5">5</option>
          <option value="4">4</option>
          <option value="3">3</option>
          <option value="2">2</option>
          <option value="1">1</option>

          ))}
        </select>
      </div>

      {/* SORT */}
      <div style={{ minWidth: 150 }}>
        <label>Sort By</label>
        <select
          className="form-select"
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
        >
          <option value="">Select</option>
          <option value="new">Newest</option>
          <option value="low_high">Price Low → High</option>
          <option value="high_low">Price High → Low</option>
        </select>
      </div>

    </div>
  );
}

export default Filters;
